import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import "../index.css"

import CrossImg from "../../../images/cross.png"
import ExclamationImg from "../../../images/exclamation.png"
import HourGlassImg from "../../../images/hourglass.png"
import GreenTick from "../../../images/greentick.png"
import SingleTickImg from "../../../images/singletick.png"
import DoubleTickImg from "../../../images/double-tick.png"
import CheckCircleImg from "../../../images/check-circle.png"


import Button from "../../../helpers/Button";
import DropDownField from "../../../helpers/DropDownField";

import { Ripple } from "primereact/ripple";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";

import SellerStock from "./Stock";

import { getMaterialsInStock } from "../../../services/api/sellerReq";
import { getBuyerProductSpecification, getMaterialMasterDetailsTooltip, getProductName, getProductQty, getUOMStr } from "../../../utils";
import { useDispatch } from "react-redux";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import _ from "lodash";
import { Checkbox } from "primereact/checkbox";
import { stockWarehousesParser } from "../../../parserFunctions";



const ProductComponent = (props) => {
    const { sellerReqs, sellersData, selectedBuyerReqItems, stockWarehouses, materialData, handleOnAddStock,  setSelectedItemId, deliveryAddressList, sellerReqItems, buyerReq, buyerReqItem, companyBusinessTypes, handleAddClick, handleOnDeleteClick, handleSelectReqItem, handleDeliveryAddressChange, vendorRateContractItems } = props
 
    const [isStockVisible, setIsStockVisible] = useState(false)
    const [isStockLoading, setIsStockLoading] = useState(false)
    const [stockMaterials, setStockMaterials] = useState([])

    const dispatch = useDispatch()

    const handleAddressChange = (e, buyerReqItemId) => {
        handleDeliveryAddressChange(e, buyerReqItemId)
    }
    const handleOnUseStockClick = async (materialId) => {
        setSelectedItemId(buyerReqItem?.buyerReqItemId)
        setIsStockLoading(true)
        let data = {
            materialIds : [materialId]
        }
        const response = await getMaterialsInStock(data)
        if (response?.failure){
            dispatch(raiseToast({severity:'error', summary: response.message, detail:'Stock Materials', life: 3000}))
        }else{
            setStockMaterials(stockWarehousesParser(response?.data))
        }
        setIsStockLoading(false)
    }

    const productTemplate = (options, buyerReqItem, relatedSellerDetails, relatedSellerReqItems) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-between`;
        let deliveryAddress = [ ...deliveryAddressList ]
        buyerReqItem.delAddrId = deliveryAddress?.length === 1 ? deliveryAddress[0]?.shipAddrId : buyerReqItem?.delAddrId
        let totalWeightage = 0

        let imageUrl=""
        let warningMessage = ""

        let totalProductVendorScore = 0
        let totalProductQuotationScore = 0
        relatedSellerDetails = relatedSellerDetails.map(eachSeller => {
            if (eachSeller.businessTypeId === null && eachSeller.companyId !== eachSeller.pmCompanyId){
                eachSeller.businessTypeId = 5
            }
            if (eachSeller.companyId === eachSeller.pmCompanyId){
                eachSeller.businessTypeId = 6
            }
            let relatedBusinessType = companyBusinessTypes?.find(eachBusinessType => eachBusinessType.businessTypeId === eachSeller.businessTypeId)
            let relatedSellerReqItem 
            if(relatedBusinessType){
                totalWeightage += relatedBusinessType.sourcingWeight
                const relatedSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq?.userId === eachSeller?.userId)
                relatedSellerReqItem = sellerReqItems?.find(eachSellerReqItem => eachSellerReqItem?.sellerReqId === relatedSellerReq?.sellerReqId && eachSellerReqItem?.buyerReqItemId === buyerReqItem?.buyerReqItemId && eachSellerReqItem?.statusId === 1)
                if (!relatedSellerReqItem?.isNew){
                    totalProductVendorScore += relatedBusinessType?.sourcingWeight
                    if (relatedSellerReqItem?.quotUnitPrice > 0){
                        totalProductQuotationScore += relatedBusinessType?.sourcingWeight
                    }
                }
            }
        
            return {...eachSeller, weightage : relatedBusinessType?.sourcingWeight}
        })
        const relatedSellerReqIds = relatedSellerReqItems.map(eachSellerReqItem => eachSellerReqItem.sellerReqId)
        const relatedSellerReqs = sellerReqs.filter(eachSellerReq => relatedSellerReqIds.includes(eachSellerReq.sellerReqId))
        const relatedVendorRateContractIds = []
        relatedSellerReqs.map(eachSellerReq => {
            if (eachSellerReq.vendorRateContractId){
                relatedVendorRateContractIds.push(eachSellerReq.vendorRateContractId)
            }
        })
                                       
        const relatedVendorRateContractItem = vendorRateContractItems.find(eachVendorRateContract => relatedVendorRateContractIds.includes(eachVendorRateContract.vendorRateContractId))

        if (relatedVendorRateContractItem){
            totalProductQuotationScore = 100
        }

        if (totalWeightage <= 100){
            imageUrl = CrossImg
            warningMessage = "Please Add the Vendors. Vendor Scoring Should be  greater than or equal to 100."
        }
        if ((totalProductVendorScore + totalProductQuotationScore) < 100 && totalWeightage !== 0){
            imageUrl = ExclamationImg
            warningMessage = "Add the Vendors and Please Fill the Quotation Details from each Vendor."   
        }
        if (totalProductQuotationScore < 100 && (totalProductVendorScore + totalProductQuotationScore) >= 100){
            imageUrl = HourGlassImg
            warningMessage = "Please Fill the Quotation Details from each Vendor"
        }
        if (totalProductQuotationScore >= 100){
            imageUrl = GreenTick
            warningMessage = "Completed"
        }
        // const materialDetails = getMaterialMasterDetailsTooltip(materialData)
        const qtyStr = getProductQty(buyerReqItem?.qty)
        const uomStr = getUOMStr(materialData?.UOM, materialData?.UOMValue)
        const productName = getProductName(materialData?.brandName, materialData?.productName, materialData?.variantName)
        const productSpecification = getBuyerProductSpecification(materialData?.companyProdSpec, materialData?.productSpecification, materialData?.UOM, materialData?.UOMValue)
        return (
            <div className={className} style={{ display: "flex", justifyContent: "space-between", padding:"0px 10px",fontFamily: "Amazon Ember,Arial,sans-serif", alignItems: "center" }}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <div style={{display:"flex", justifyContent : "space-between", flex: 1,}}>
                    <div className="flex flex-row">
                    <Checkbox inputId="selectAllReqItems" className="mt-4 ml-2" checked={selectedBuyerReqItems.includes(buyerReqItem?.buyerReqItemId)} onChange={() => handleSelectReqItem(buyerReqItem?.buyerReqItemId)}/>
                    <div className="mt-2" style={{marginLeft : "30px", alignItems: "center"}}>
                        <p className="mt-2 mb-1"><span style={{fontWeight: 700}}>{buyerReqItem?.materialId}</span> | {productName} {productSpecification && ` | ${productSpecification}`} - {uomStr}</p>
                        <p className="mt-1 mb-0" style={{}}>Qty: <span style={{fontWeight: 600}}>{qtyStr}</span></p>
                    </div>
                    </div>
                    <div className="flex flex-column col-3" style={{width: "225px", marginTop: "4px",marginRight: "50px"}}>
                        <DropDownField labelText="Delivery Address" options={deliveryAddress} value={buyerReqItem.delAddrId} disabled={totalProductVendorScore > 0} optionLabel="warehouseName" optionValue="shipAddrId" panelStyle={{ width: "225px"}} onChange={e => handleAddressChange(e, buyerReqItem.buyerReqItemId)}/>
                    </div>
                </div>
                <div style={{ alignItems: "flex-end" }}>
                    <div className={`custom-tool-tip-${buyerReqItem?.buyerReqItemId}`}>
                        <img src={imageUrl} style={{width: "25px"}} className={`custom-tool-tip-${buyerReqItem?.buyerReqItemId}`}/>
                    </div>
                    {/* <Button icon={icon} className={`custom-tool-tip-${buyerReqItem?.buyerReqItemId}`} rounded severity={statusColor} aria-label="Filter" data-pr-position="left" data-pr-at="left-6 top"  /> */}
                    <Tooltip target={`.custom-tool-tip-${buyerReqItem?.buyerReqItemId}`} position="top" autoHide classname="send-req-tooltip" >
                        <p className="m-0" >{warningMessage}</p>
                    </Tooltip>
                </div>
            </div>
        )
    }

    const handleDeleteClick = (userId) => {
        if (window.confirm("Do You want to remove the Seller for this Requirement?")){
            handleOnDeleteClick(buyerReqItem.buyerReqItemId, userId)
        }
    }

    const handleOnAddClick = (buyerReqItemId) => {
        handleAddClick(buyerReqItemId)
    }

    const relatedStockWarehouse = stockWarehouses?.find(eachStockWarehouse => eachStockWarehouse?.materialId === buyerReqItem?.materialId)

    let className = ""
    if (relatedStockWarehouse?.materialId){
        className = "small-btn"
    }else{
        className = "h-2rem small-btn p-2 action-btn hover:surface-400 hover:text-700 surface-300"
    }

    return (
        <>
            <Panel className="mb-2" headerTemplate={(options) => productTemplate(options, buyerReqItem, sellersData, sellerReqItems)} toggleable>
                { 
                    sellersData.length > 0 && 
                    <div style={{ fontSize:"12px" }}>
                        <table className='send-req-custom-table' style={{ textAlign: "center" }}>
                            <thead style={{}} >
                                <tr className="send-req-custom-tr" style={{fontWeight: "600"}}>
                                    <th className="send-req-custom-th" style={{ fontSize:"14px" }}>Sr.No</th>
                                    <th className="send-req-custom-th" style={{ fontSize:"14px" }}>Seller Name</th>
                                    <th className="send-req-custom-th" style={{ fontSize:"14px" }}>Seller Type</th>
                                    <th className="send-req-custom-th" style={{ fontSize:"14px" }}>Company Name</th>
                                    <th className="send-req-custom-th" style={{ fontSize:"14px" }}>Branch</th>
                                    <th className="send-req-custom-th" style={{ fontSize:"14px" }}>Email Id</th>
                                    <th className="send-req-custom-th">
                                        {/* <Button className="decrement-btn-icon small-btn" icon="pi pi-minus-circle plus-icons" text /> */}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    sellerReqs?.map((eachSellerReq, index) => {
                                        const relatedSeller = sellersData.find(eachSeller => eachSeller.userId === eachSellerReq.userId && eachSeller?.branchId === eachSellerReq?.branchId)
                                        const relatedSellerReqItems = sellerReqItems?.filter(eachSellerReqItem => eachSellerReqItem?.sellerReqId === eachSellerReq?.sellerReqId && eachSellerReqItem?.buyerReqItemId === buyerReqItem?.buyerReqItemId)
                                        const activeSellerReqItem = relatedSellerReqItems?.find(eachSellerReqItem => eachSellerReqItem?.statusId === 1)
                                        const expiredSellerReqItem = relatedSellerReqItems?.find(eachSellerReqItem => eachSellerReqItem?.statusId === 2)
                                        const isURDSeller = relatedSeller.gstinCode !== 'URD' ? false : true
                                        let imgUrl = ""
                                        let tooltipString = ""
                                        if (activeSellerReqItem?.sellerReqItemId){
                                            if (activeSellerReqItem?.isNew){
                                                if (!expiredSellerReqItem?.sellerReqItemId){
                                                    tooltipString = "Please Send the mail."
                                                }else{
                                                    tooltipString = "Vendor Added, Please Send the mail."
                                                }
                                            }
                                            else if (!activeSellerReqItem?.isNew && !activeSellerReqItem?.quotTotalAmountWithTax > 0){
                                                imgUrl = SingleTickImg
                                                tooltipString = "Enter the quotation Details"
                                            }else if (activeSellerReqItem?.quotQty > 0 && !eachSellerReq?.docProof?.length > 0 && activeSellerReqItem?.quotTotalAmountWithTax > 0){
                                                imgUrl = DoubleTickImg
                                                tooltipString = "Upload the document"
                                            }else if (activeSellerReqItem?.quotQty > 0 && eachSellerReq?.docProof?.length > 0 && activeSellerReqItem?.quotTotalAmountWithTax > 0){
                                                imgUrl = CheckCircleImg
                                                tooltipString = "Completed"
                                            }
                                        }
                                        return(<tr className="send-req-custom-tr" style={{fontSize:"14px"}} key={`sellerReq-${eachSellerReq.sellerReqId}`}>
                                            <td className="send-req-custom-td">{index + 1}</td>
                                            <td className="send-req-custom-td">
                                                <Link to={`#${relatedSeller?.userId}`} className={`custom-tool-tip-${activeSellerReqItem?.sellerReqItemId}`} smooth style={{textDecoration: "none"}}>
                                                    {relatedSeller?.name}
                                                </Link>
                                                <img src={imgUrl} style={{height : 15,  marginTop: 0, marginLeft: 10,}} className=""/>
                                            </td>
                                            <Tooltip target={`.custom-tool-tip-${activeSellerReqItem?.sellerReqItemId}`} position="right" autoHide >
                                                <p className="m-0">{tooltipString}</p>
                                            </Tooltip>
                                            <td className="send-req-custom-td">{relatedSeller?.businessType} ({relatedSeller?.sourcingWeight}) {isURDSeller && ` - URD`}</td>
                                            <td className="send-req-custom-td">{relatedSeller?.companyName}</td>
                                            <td className="send-req-custom-td">{relatedSeller?.branchName}</td>
                                            <td className="send-req-custom-td">{relatedSeller?.emailId}</td>
                                            <td className="send-req-custom-th">
                                                <Button className="decrement-btn-icon small-btn" icon="pi pi-minus-circle plus-icons" severity="danger" text onClick={() => handleDeleteClick(eachSellerReq?.userId)} permissions={[195]} />
                                            </td>
                                        </tr>)
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                }
                <div className="flex flex-row align-items-center">
                    <div>                                
                        <Button className="increment-btn-icon small-btn mb-1" icon="pi pi-plus-circle plus-icons" text onClick={() => handleOnAddClick(buyerReqItem.buyerReqItemId)} disabled={buyerReq.reqTagId === 4} tooltip={buyerReq.reqTagId === 4 ? 'VMI products should be used from stock only!' : ''} tooltipOptions={{ position: 'top', showOnDisabled: true, }} permissions={[189]}/>                            
                    </div>
                    <div style={{marginLeft : "30px", alignItems: "flex-end"}}>
                        <Button 
                            className={`${className} my-2`} 
                            label="Use Stock" 
                            style={{fontSize: "12px"}} 
                            onClick={() => {setIsStockVisible(true); handleOnUseStockClick(buyerReqItem?.materialId)}} 
                            disabled={buyerReq.orderTypeId===3} 
                            tooltip={buyerReq.orderTypeId===3 ? `Can't use useStock in stock requirement(ordertype = STOCK)` : ''}
                            tooltipOptions={{ position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150 }}
                            permissions={[190]}
                        />
                    </div>
                </div>
            </Panel>
            <Dialog header="Stock Material" visible={isStockVisible} style={{ width: '35vw', height: '30vh' }} onHide={() => setIsStockVisible(false)}>
                <SellerStock stockMaterials={stockMaterials} handleOnAddStock={handleOnAddStock} setIsStockVisible={setIsStockVisible} isStockLoading={isStockLoading} stockWarehouses={stockWarehouses}/>
            </Dialog>
        </>
        
    )

}

export default ProductComponent